import CatalogComponent from '../components/catalog/catalog'

const CatalogDetail = () => <CatalogComponent />

export default CatalogDetail;